import { render, staticRenderFns } from "./SettingsMain.vue?vue&type=template&id=47f87ea4&scoped=true"
import script from "./SettingsMain.vue?vue&type=script&lang=js"
export * from "./SettingsMain.vue?vue&type=script&lang=js"
import style0 from "./SettingsMain.vue?vue&type=style&index=0&id=47f87ea4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f87ea4",
  null
  
)

export default component.exports